var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { Container } from "reactstrap";
import { space } from "styled-system";
export var DisclaimerWrapper = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), space);
export var Note = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.625rem;\n\n  a {\n    color: inherit;\n  }\n"], ["\n  font-size: 0.625rem;\n\n  a {\n    color: inherit;\n  }\n"])));
var templateObject_1, templateObject_2;